import { actionGenerator } from '../../utils/redux/actionGenerator';
import { ETabActionTypes, TSetActiveTabType } from './types';
import { ETab } from '../../types/tab';

export const setActiveTab: (payload: ETab) => TSetActiveTabType = actionGenerator<ETabActionTypes.SetActiveTab, ETab>(
  ETabActionTypes.SetActiveTab,
);
